<div class="min-h-[70vh] p-4 sm:p-0">
  <div class="flex flex-col sm:flex-row sm:items-center justify-between mb-6">
    <h2 class="text-xl sm:text-2xl font-semibold text-gray-800 w-full">
      Ofertas de trabajo
    </h2>

    <button
      (click)="goToCreate()"
      class="px-3 py-2 sm:px-4 sm:py-2 shadow-lg bg-primary text-white rounded-md hover:bg-primary/95 transition mt-2 sm:mt-0 w-full sm:w-auto text-sm sm:text-base"
    >
      <span class="hidden sm:inline">Crear nueva oferta de empleo</span>
      <span class="sm:hidden">Crear oferta</span>
    </button>
  </div>

  <app-loading
    [text]="'Cargando ofertas de empleo'"
    *ngIf="isLoading"
  ></app-loading>

  <div *ngIf="!isLoading && jobOffers.length > 0; else noOffers">
    <table class="min-w-full table-auto text-sm text-left">
      <thead class="text-gray-700 border-b border-gray-200">
        <tr>
          <th class="py-2 px-4">Nombre</th>
          <th class="py-2 px-4 hidden sm:table-cell">Fecha</th>
          <th class="py-2 px-4 hidden sm:table-cell">Estado</th>
          <th class="py-2 px-4 text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let offer of jobOffers"
          class="border-b border-gray-200 hover:bg-indigo-50/20 transition"
        >
          <td class="py-3 px-4 max-w-xs truncate">
            {{ offer.title }}
          </td>
          <td class="py-3 px-4 hidden sm:table-cell">
            {{ offer.publicationDate | date : "mediumDate" }}
          </td>
          <td class="py-3 px-4 hidden sm:table-cell">
            <span
              class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
              [ngClass]="{
                'bg-green-100 text-green-800':
                  offer.publicationStatus === 'Publicado',
                'bg-red-100 text-red-800':
                  offer.publicationStatus === 'Finalizado'
              }"
            >
              {{ offer.publicationStatus | titlecase }}
            </span>
          </td>
          <td class="py-3 px-4 text-right flex items-center justify-end gap-2">
            <div class="sm:hidden shrink-0">
              <span
                class="inline-block w-3 h-3 rounded-full"
                [ngClass]="{
                  'bg-green-500': offer.publicationStatus === 'Publicado',
                  'bg-red-500': offer.publicationStatus === 'Finalizado'
                }"
                title="{{ offer.publicationStatus }}"
              ></span>
            </div>
            <button
              class="px-2 py-1.5 transition cursor-pointer border border-primary rounded-md hover:bg-primary hover:text-white text-primary text-sm flex items-center justify-center"
              (click)="goToDetails(offer.idJobOffer)"
            >
              <span class="hidden sm:inline">Ver detalles</span>
              <div class="sm:hidden flex align-middle justify-center">
                <ng-icon name="heroArrowRight" size="16"></ng-icon>
              </div>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #noOffers>
    <div *ngIf="!isLoading" class="text-center text-gray-500 py-10">
      <p class="text-lg">No hay ofertas de trabajo publicadas aún.</p>
      <p class="text-sm mt-2">
        Haz clic en <strong>"Crear nueva oferta de empleo"</strong> para
        publicar la primera.
      </p>
    </div>
  </ng-template>
</div>
